import { View, Text, Heading, Card } from '@smarterservices/smarter-ui';
import CopyValue from '../../Common/CopyValue';
import CONSTANTS from '../../../config/constants';

/**
 * ExamPasswordsCard — Displays the unique exam password and the actual exam password.
 *
 * The unique password can be shared with the test taker.
 * The actual password must NEVER be communicated to the test taker.
 *
 * @param {Object} props
 * @param {string} props.uniquePassword - The unique exam password (safe to share)
 * @param {string} props.actualPassword - The actual exam password (confidential)
 * @returns {JSX.Element}
 */
function ExamPasswordsCard({ uniquePassword, actualPassword }) {
  return (
    <Card>
      <Card.Header
        background="brand"
        padding={CONSTANTS.STYLES.CARD_HEADER_PADDING}
      >
        <Card.Title>
          <Text variant={CONSTANTS.STYLES.CARD_TITLE_VARIANT}>
            Exam Passwords
          </Text>
        </Card.Title>
      </Card.Header>
      <Card.Body padding={CONSTANTS.STYLES.CARD_BODY_PADDING}>
        <View as="div">
          <View
            as="div"
            margin="none none x-small none"
            borderWidth="small"
            borderColor="secondary"
            borderRadius="large"
            padding="small"
          >
            <Heading level="h4" margin="none none small none">Unique Password</Heading>
            <View as="div" margin="none none none none">
              <Text size="small">
                {uniquePassword}
                <CopyValue text={uniquePassword} />
              </Text>
            </View>
          </View>
          <View
            as="div"
            borderWidth="small"
            borderColor="secondary"
            borderRadius="large"
            padding="small"
          >
            <Heading level="h4" margin="none none small none">Actual Password</Heading>
            <View as="div" margin="none none none none">
              <Text size="x-small" color="danger">
                This password CANNOT under any circumstances be communicated to the tester
              </Text>
              <View as="div" margin="small none none none">
                <Text size="small">
                  {actualPassword}
                  <CopyValue text={actualPassword} margin="none none none small" />
                </Text>
              </View>
            </View>
          </View>
        </View>
      </Card.Body>
    </Card>
  );
}

export default ExamPasswordsCard;
